import {CompSheet, CompType, MarkerBlock} from './types';

/**
 * Row layout of the denormalized template (`BulkUploadCompsTemplate.xlsx`):
 *   row 1  — section banner, merged across each marker block (value only in the
 *            top-left cell, so the reader forward-fills it across the block).
 *   row 2  — column headers.
 *   row 3+ — data; one row = one Portfolio + Building + Comp, linked positionally.
 */
const BANNER_ROW = 1;
const HEADER_ROW = 2;
const FIRST_DATA_ROW = 3;

/** The data worksheets, one per comp type. */
const DATA_SHEETS: CompSheet[] = ['Lease', 'Building Sale', 'Land Sale'];

/** Non-data sheets to ignore. */
const IGNORED_SHEETS = ['Standard Fields'];

const SHEET_TO_COMP_TYPE: Record<CompSheet, CompType> = {
  'Lease': 'Lease',
  'Building Sale': 'Building Sale',
  'Land Sale': 'Land Sale',
};

/**
 * Banner labels beginning the portfolio and building blocks. Any other banner is
 * the comp block — its text varies by sheet, so it's identified by exclusion.
 */
const PORTFOLIO_BANNER = 'Portfolio';
const BUILDING_BANNER = 'Building';
const PORTFOLIO_FIELDS_KEY = 'competitivePortfolio';
const BUILDING_FIELDS_KEY = 'competitiveBuilding';
const compFieldsKey = (compType: CompType): string => `competitiveBuilding${compType}`;

const standardFieldsKeyFor = (block: MarkerBlock, compType: CompType): string => {
  if (block === 'portfolio') return PORTFOLIO_FIELDS_KEY;
  if (block === 'building') return BUILDING_FIELDS_KEY;
  return compFieldsKey(compType);
};

/**
 * Building-block columns that together form the address. Concatenated for
 * geocoding rather than emitted as separate fields (the model has one `address`).
 */
const ADDRESS_GROUP_HEADERS = ['Address', 'City', 'State'];

/** Fallback location (KC office) for a building whose address can't be geocoded. */
const KC_OFFICE_LOCATION = {
  latitude: 39.155630292693225,
  longitude: -94.57613179930004,
};

export {
  BANNER_ROW,
  HEADER_ROW,
  FIRST_DATA_ROW,
  DATA_SHEETS,
  IGNORED_SHEETS,
  SHEET_TO_COMP_TYPE,
  PORTFOLIO_BANNER,
  BUILDING_BANNER,
  PORTFOLIO_FIELDS_KEY,
  BUILDING_FIELDS_KEY,
  compFieldsKey,
  standardFieldsKeyFor,
  ADDRESS_GROUP_HEADERS,
  KC_OFFICE_LOCATION,
};
